<mat-card appearance="outlined" class="ai-card">
  <mat-card-content class="d-flex flex-column gap-2 p-3">
    <div class="d-flex align-items-center justify-content-between gap-2">
      <span class="mat-title-small">Properties</span>
      <div class="d-flex align-items-center gap-1">
        @if (isEditing()) {
          <button matButton (click)="cancelEdit()">Cancel</button>
        }
        @if (editable()) {
          <button
            matIconButton
            (click)="toggleEditOrSave()"
            [disabled]="isEditing() && !dirty()"
            [attr.aria-label]="isEditing() ? 'Save properties' : 'Edit properties'"
          >
            <mat-icon>{{ isEditing() ? 'check' : 'edit' }}</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="d-flex flex-column">
      @for (row of rows(); track $index) {
        @if ($index > 0) {
          <mat-divider />
        }
        <div class="d-flex align-items-center gap-2 py-2">
          @if (row.isNew && isEditing()) {
            <mat-form-field class="w-25 flex-shrink-0" subscriptSizing="dynamic">
              <mat-label>Key</mat-label>
              <input matInput [value]="row.key" (input)="updateKey($index, $any($event.target).value)" />
            </mat-form-field>
          } @else {
            <span class="w-25 flex-shrink-0 fw-bold text-truncate">{{ row.key }}</span>
          }

          <div class="flex-fill d-flex align-items-center gap-1">
            @if (isEditing() && !row.locked) {
              @if (row.type === 'boolean') {
                <mat-checkbox
                  [checked]="row.value === true"
                  (change)="updateBooleanValue($index, $event.checked)">
                  {{ row.value === true ? 'true' : 'false' }}
                </mat-checkbox>
              } @else if (row.type === 'object' || row.type === 'array') {
                <span class="flex-fill text-body-secondary" [title]="displayValue(row.value)">
                  {{ displayValue(row.value) }}
                </span>
                <button matIconButton (click)="viewJson(row.value, row.key)" aria-label="View JSON value">
                  <mat-icon>search</mat-icon>
                </button>
              } @else {
                <mat-form-field class="flex-fill" subscriptSizing="dynamic">
                  <mat-label>Value</mat-label>
                  <input
                    matInput
                    [type]="row.type === 'number' ? 'number' : 'text'"
                    [value]="row.value"
                    (input)="updateValue($index, $any($event.target).value)" />
                </mat-form-field>
              }
            } @else if (row.type === 'object' || row.type === 'array') {
              <span class="flex-fill" [title]="displayValue(row.value)">
                {{ displayValue(row.value) }}
              </span>
              <button matIconButton (click)="viewJson(row.value, row.key)" aria-label="View JSON value">
                <mat-icon>search</mat-icon>
              </button>
            } @else {
              <span class="flex-fill">{{ displayValue(row.value) }}</span>
            }
          </div>

          @if (isEditing() && !row.locked) {
            <button matIconButton (click)="removeRow($index)" aria-label="Delete property">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      } @empty {
        <span class="text-body-secondary py-2">No properties</span>
      }
    </div>

    @if (isEditing()) {
      <button matButton (click)="addRow()">
        <mat-icon>add</mat-icon>
        Add property
      </button>
    }
  </mat-card-content>
</mat-card>
